<script setup lang="ts">
import maintenanceImageUrl from '@/assets/images/maintenance.webp'
import { maintenanceModeService } from '@/services/maintenanceModeService'

const isMaintenanceActive = maintenanceModeService.isActive
</script>

<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition ease-out duration-300"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <section
        v-if="isMaintenanceActive"
        class="fixed inset-0 z-200 flex items-center justify-center overflow-y-auto bg-stone-950 px-5 py-8 text-white"
        role="status"
        aria-live="polite"
      >
        <div class="w-full max-w-3xl text-center">
          <img
            :src="maintenanceImageUrl"
            alt="Maintenance mode"
            class="mx-auto mb-8 max-h-[42vh] w-full max-w-xl rounded-3xl object-contain shadow-2xl shadow-black/40"
            width="960"
            height="640"
          />
          <p class="mb-3 text-sm font-bold uppercase tracking-[0.35em] text-amber-300">
            Scheduled maintenance
          </p>
          <h1 class="mb-4 text-3xl font-bold tracking-tight sm:text-5xl">
            routecamp is taking a short break
          </h1>
          <p class="mx-auto max-w-xl text-base leading-7 text-stone-200 sm:text-lg">
            We are deploying an update right now. Keep this page open and routecamp will reload
            automatically when the app is ready.
          </p>
        </div>
      </section>
    </Transition>
  </Teleport>
</template>
